export default __webpack_public_path__ + "81afe0ffec019498730386a6b8ee2e60.svg";